"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_ICONS = exports.ICON_NAMES = exports.ICON_CATALOG = void 0;
/**
 * 제품에서 뜻이 고정된 아이콘의 의미 이름과 iconoir 이름의 대응표.
 * 카테고리 묶음이 원본이고 ICON_NAMES는 이를 펼친 조회용 맵이므로,
 * 새 아이콘을 맞는 카테고리에 넣으면 문서 페이지의 목록에도 함께 나온다.
 */
exports.ICON_CATALOG = {
    actions: {
        ADD: 'plus',
        ADD_CIRCLE: 'plus-circle-solid',
        DISMISS: 'xmark',
        CLOSE: 'xmark',
        COPY: 'copy',
        COPY_SUCCESS: 'check',
        DELETE: 'trash',
        FILTER: 'filter',
        IMPORT: 'import',
        LOG_OUT: 'log-out',
        MORE_ACTIONS: 'more-vert',
        SHOW_MORE: 'more-horiz',
        REFRESH: 'refresh',
        RETRY: 'refresh-double',
        SETTINGS: 'settings',
        SUBMIT: 'arrow-up',
        SHARE: 'arrow-up-right',
        CAMERA: 'camera',
        HIDE: 'eye-closed',
        VIEW: 'eye',
        THUMBS_UP: 'thumbs-up',
        DISLIKE: 'thumbs-down',
        GRID_VIEW: 'view-grid',
        LIST_VIEW: 'table-rows',
    },
    navigations: {
        BACK: 'arrow-left',
        EXPAND: 'nav-arrow-down',
        FORWARD: 'arrow-right',
        HOME_PAGE: 'home-simple-door',
        MENU: 'menu-scale',
        PREVIOUS: 'arrow-left',
        NEXT: 'arrow-right',
        SCROLL_TOP: 'arrow-up',
    },
    status: {
        ERROR: 'xmark-circle',
        DONE: 'check-circle',
        INFO: 'info-circle',
        SUCCESS: 'check-circle',
        WARNING: 'warning-triangle',
        FAILURE: 'xmark-circle',
        IDLE: 'circle',
    },
    selection: {
        BOOKMARK: 'bookmark',
        BOOKMARK_SELECTED: 'bookmark-solid',
        CHECK: 'check',
        CURRENT: 'map-pin',
        FAVORITE: 'star',
        FAVORITE_SELECTED: 'star-solid',
        LIKE: 'heart',
        LIKE_SELECTED: 'heart-solid',
        PRESSED: 'check-square',
        SELECTED: 'check-circle',
    },
    brand: {
        APPLE: 'apple',
        FACEBOOK: 'facebook',
        FIGMA: 'figma',
        GITHUB: 'github',
        GOOGLE: 'google',
        // Iconoir에는 Notion 마크가 없어 Notion의 단위인 페이지 아이콘으로 대신한다.
        NOTION: 'page',
        PINTEREST: 'pinterest',
    },
    theme: {
        BRUTAL_MODE: 'square',
        DARK_MODE: 'half-moon',
        GLASS_MODE: 'droplet',
        LIGHT_MODE: 'sun-light',
        PALETTE: 'palette',
    },
    etc: {
        BOOK: 'book',
        CODE: 'code',
        DOCUMENT: 'page',
        DOCUMENT_CHECK: 'clipboard-check',
        FLOWER: 'flower',
        TREND_UP: 'graph-up',
        TREND_DOWN: 'graph-down',
        LINK: 'link',
        VIDEO: 'media-video',
        BOX: 'box-iso',
        CREDIT_CARD: 'credit-card',
        CUBE_SCAN: 'cube-scan',
        DELIVERY: 'delivery-truck',
        GROUP: 'group',
        PROFILE: 'profile-circle',
        USER: 'user',
        CLICK: 'cursor-pointer',
        MOUSE_BUTTON: 'mouse-button-left',
        SPARKS: 'sparks',
        WIFI: 'wifi',
        EMPTY: 'glass-empty',
        COMMENT: 'message',
        MAIL: 'mail',
        NOTIFICATION: 'bell',
        HOME: 'air-conditioner',
        SORT: 'arrow-separate-vertical',
        DATE: 'calendar',
        LOCK: 'lock',
        SEARCH: 'search',
        SUBTRACT: 'minus',
    },
};
exports.ICON_NAMES = {
    ...exports.ICON_CATALOG.actions,
    ...exports.ICON_CATALOG.navigations,
    ...exports.ICON_CATALOG.status,
    ...exports.ICON_CATALOG.selection,
    ...exports.ICON_CATALOG.brand,
    ...exports.ICON_CATALOG.theme,
    ...exports.ICON_CATALOG.etc,
};
/** 상태 톤마다 쓰는 아이콘. 톤을 가진 컴포넌트와 Feedback 문서가 함께 참조한다. */
exports.STATUS_ICONS = {
    success: exports.ICON_NAMES.SUCCESS,
    info: exports.ICON_NAMES.INFO,
    warning: exports.ICON_NAMES.WARNING,
    error: exports.ICON_NAMES.ERROR,
    done: exports.ICON_NAMES.DONE,
};
//# sourceMappingURL=data:application/json;base64,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